import { useCallback, useEffect, useState } from 'react';
import { Box, CssBaseline, ThemeProvider } from '@mui/material';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { HelmetProvider } from 'react-helmet-async';

import theme from './theme';
import { useAppDispatch, useAppSelector } from '../store/configureStore';
import { initializeApp } from '../store/appSlice';
import DrawerMenu from '../../features/common/drawerMenu/DrawerMenu';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import Dialog from '../components/Dialog';
import AppSkeleton from './AppSkeleton';
import MetaTags from '../../common/components/MetaTags';

const App = () => {
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(true);
  const { paletteType } = useAppSelector((state) => state.drawerMenu);

  // Initialize app
  const initApp = useCallback(async () => {
    try {
      await dispatch(initializeApp()).unwrap();
    } catch (error) {
      console.log(error);
    }
  }, [dispatch]);

  useEffect(() => {
    const init = async () => {
      await initApp();
      setLoading(false);
    };

    init();
  }, [initApp]);

  return (
    <HelmetProvider>
      <ThemeProvider theme={theme(paletteType)}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <>
            <MetaTags
              title="SmartRisto - Your Restaurant, Smarter"
              description="The ultimate restaurant management solution to streamline your operations, from orders and table management to kitchen and staff coordination."
              imageUrl="https://smartristo.ch/assets/images/smartristo-logo.png"
            />
            {loading ? (
              <AppSkeleton />
            ) : (
              <Box sx={{ display: 'flex' }}>
                <CssBaseline />
                <ToastContainer
                  position="bottom-right"
                  hideProgressBar
                  theme="colored"
                />
                <DrawerMenu />
              </Box>
            )}
            <Dialog />
          </>
        </LocalizationProvider>
      </ThemeProvider>
    </HelmetProvider>
  );
};

export default App;
